(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
      if (customElements.get('codex-announcement-carousel')) return;

      class CodexAnnouncementCarousel extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
          this.currentIndex = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
          this.autoplay = this.dataset.autoplay === 'true';
          this.pauseOnHover = this.dataset.pauseOnHover === 'true';
          this.interval = Math.max(2000, Number(this.dataset.interval) || 4000);
          this.timer = null;

          this.onMouseEnter = () => this.stop();
          this.onMouseLeave = () => this.start();
          this.onFocusIn = () => this.stop();
          this.onFocusOut = () => this.start();
          this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
          this.onBlockSelect = (event) => {
            const item = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
            if (!item) return;
            this.stop();
            this.show(this.items.indexOf(item));
          };
          this.onBlockDeselect = () => this.start();

          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', this.onMouseEnter);
            this.addEventListener('mouseleave', this.onMouseLeave);
          }
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

          this.show(this.currentIndex, false);
          this.start();
        }

        disconnectedCallback() {
          this.stop();
          this.removeEventListener('mouseenter', this.onMouseEnter);
          this.removeEventListener('mouseleave', this.onMouseLeave);
          this.removeEventListener('focusin', this.onFocusIn);
          this.removeEventListener('focusout', this.onFocusOut);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        show(nextIndex, animate = true) {
          if (!this.items.length || nextIndex < 0) return;

          const previous = this.items[this.currentIndex];
          const next = this.items[nextIndex];
          if (!next || (previous === next && animate)) return;

          this.items.forEach((item) => {
            item.classList.remove('is-active', 'is-leaving');
            item.setAttribute('aria-hidden', 'true');
          });

          if (previous && previous !== next && animate) {
            previous.classList.add('is-leaving');
          }

          next.classList.add('is-active');
          next.setAttribute('aria-hidden', 'false');
          this.currentIndex = nextIndex;
        }

        next() {
          this.show((this.currentIndex + 1) % this.items.length);
        }

        start() {
          this.stop();
          if (!this.autoplay || this.items.length < 2 || document.hidden) return;
          this.timer = window.setInterval(() => this.next(), this.interval);
        }

        stop() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }
      }

      customElements.define('codex-announcement-carousel', CodexAnnouncementCarousel);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-image-hover-card')) return;

    class ProductImageHoverCard extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('.product-card__media');
        this.secondaryImage = this.querySelector('.product-card__secondary-image');
        if (!this.media || !this.secondaryImage) return;

        this.showSecondaryImage = () => this.classList.add('is-image-hovered');
        this.hideSecondaryImage = () => this.classList.remove('is-image-hovered');

        this.media.addEventListener('mouseenter', this.showSecondaryImage);
        this.media.addEventListener('mouseleave', this.hideSecondaryImage);
      }

      disconnectedCallback() {
        if (!this.media) return;
        this.media.removeEventListener('mouseenter', this.showSecondaryImage);
        this.media.removeEventListener('mouseleave', this.hideSecondaryImage);
      }
    }

    customElements.define('product-image-hover-card', ProductImageHoverCard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('search-discovery-addons')) {
      class SearchDiscoveryAddons extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true') return;
          this.dataset.loaded = 'true';

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              if (!entries[0].isIntersecting) return;
              this.observer.disconnect();
              this.loadRecommendations();
            }, { rootMargin: '0px 0px 200px 0px' });
            this.observer.observe(this);
          } else {
            this.loadRecommendations();
          }
        }

        async loadRecommendations() {
          const url = this.dataset.url;
          if (!url) {
            this.hidden = true;
            return;
          }

          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Unable to load complementary products.');
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const source = documentFragment.querySelector('search-discovery-addons [data-complementary-results]');
            const target = this.querySelector('[data-complementary-results]');

            if (source && target && source.innerHTML.trim()) {
              target.innerHTML = source.innerHTML;
              this.hidden = false;
            } else {
              this.hidden = true;
            }
          } catch (error) {
            this.hidden = true;
            console.error(error);
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }

      customElements.define('search-discovery-addons', SearchDiscoveryAddons);
    }

    if (customElements.get('premium-product-section')) return;

    class PremiumProductSection extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.premium-product__form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.addButton = this.querySelector('[data-product-add]');
        this.addButtonText = this.querySelector('[data-add-button-text]');
        this.message = this.querySelector('[data-product-message]');
        this.price = this.querySelector('[data-product-price]');
        this.comparePrice = this.querySelector('[data-compare-price]');
        this.savingBadge = this.querySelector('[data-saving-badge]');
        this.variantData = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
        this.galleryPrevious = this.querySelector('[data-gallery-previous]');
        this.galleryNext = this.querySelector('[data-gallery-next]');
        this.currentMediaIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => this.showMedia(thumbnail.dataset.galleryThumbnail));
        });
        this.galleryPrevious?.addEventListener('click', () => this.stepMedia(-1));
        this.galleryNext?.addEventListener('click', () => this.stepMedia(1));
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
        this.querySelectorAll('[data-product-option]').forEach((control) => {
          control.addEventListener('change', () => this.onOptionChange());
        });
        this.querySelector('[data-copy-code]')?.addEventListener('click', (event) => this.copyCode(event.currentTarget));
        this.form?.addEventListener('submit', (event) => this.onSubmit(event));

        const currentVariant = this.variantData.find((variant) => String(variant.id) === String(this.variantInput?.value));
        this.filterVariantMedia(currentVariant);
        this.startCountdown();
      }

      getVisibleSlides() {
        return this.slides.filter((slide) => slide.dataset.variantHidden !== 'true');
      }

      filterVariantMedia(variant) {
        const selectedVariantId = String(variant?.id || '');
        const shouldFilter = this.dataset.hideVariantMedia === 'true' && Boolean(variant?.featured_media?.id);

        this.slides.forEach((slide) => {
          const associatedVariantIds = (slide.dataset.variantMediaIds || '').split(',').filter(Boolean);
          const shouldHide = shouldFilter && associatedVariantIds.length > 0 && !associatedVariantIds.includes(selectedVariantId);
          slide.dataset.variantHidden = shouldHide ? 'true' : 'false';
        });

        this.thumbnails.forEach((thumbnail) => {
          const associatedVariantIds = (thumbnail.dataset.variantMediaIds || '').split(',').filter(Boolean);
          const shouldHide = shouldFilter && associatedVariantIds.length > 0 && !associatedVariantIds.includes(selectedVariantId);
          thumbnail.dataset.variantHidden = shouldHide ? 'true' : 'false';
        });

        const visibleSlides = this.getVisibleSlides();
        if (!visibleSlides.length) return;

        const selectedMediaId = variant?.featured_media?.id;
        const activeSlide = visibleSlides.find((slide) => slide.classList.contains('is-active'));
        if (selectedMediaId && visibleSlides.some((slide) => String(slide.dataset.mediaId) === String(selectedMediaId))) {
          this.showMedia(selectedMediaId);
        } else if (activeSlide) {
          this.showMedia(activeSlide.dataset.mediaId);
        } else {
          this.showMedia(visibleSlides[0].dataset.mediaId);
        }
        this.updateGalleryControls();
      }

      updateGalleryControls() {
        const isSingleMedia = this.getVisibleSlides().length < 2;
        this.galleryPrevious?.toggleAttribute('disabled', isSingleMedia);
        this.galleryNext?.toggleAttribute('disabled', isSingleMedia);
      }

      showMedia(mediaId) {
        const visibleSlides = this.getVisibleSlides();
        const target = visibleSlides.find((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (!target) return;
        this.slides.forEach((slide) => {
          const active = slide === target;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.classList.toggle('is-active', String(thumbnail.dataset.galleryThumbnail) === String(mediaId));
        });
        this.currentMediaIndex = visibleSlides.indexOf(target);
      }

      stepMedia(direction) {
        const visibleSlides = this.getVisibleSlides();
        if (visibleSlides.length < 2) return;
        const activeIndex = visibleSlides.findIndex((slide) => slide.classList.contains('is-active'));
        const currentIndex = activeIndex >= 0 ? activeIndex : 0;
        const nextIndex = (currentIndex + direction + visibleSlides.length) % visibleSlides.length;
        this.showMedia(visibleSlides[nextIndex].dataset.mediaId);
      }

      changeQuantity(amount) {
        if (!this.quantityInput) return;
        const current = Math.max(1, Number(this.quantityInput.value) || 1);
        this.quantityInput.value = Math.max(1, current + amount);
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      getSelectedOptions() {
        return Array.from(this.querySelectorAll('[data-option-position]'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((group) => {
            const checked = group.querySelector('input[data-product-option]:checked');
            const select = group.querySelector('select[data-product-option]');
            return checked?.value || select?.value || '';
          });
      }

      onOptionChange() {
        const selectedOptions = this.getSelectedOptions();
        const variant = this.variantData.find((item) =>
          item.options.every((option, index) => option === selectedOptions[index])
        );
        if (!variant) return;

        this.variantInput.value = variant.id;
        this.updatePrice(variant);
        this.updateAvailability(variant);

        this.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = Number(group.dataset.optionPosition) - 1;
          const selectedLabel = this.querySelector(`[data-selected-option="${position + 1}"]`);
          if (selectedLabel) selectedLabel.textContent = selectedOptions[position];
        });

        this.filterVariantMedia(variant);
        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format((cents || 0) / 100);
      }

      updatePrice(variant) {
        if (this.price) this.price.textContent = this.formatMoney(variant.price);
        if (this.comparePrice) {
          const onSale = variant.compare_at_price > variant.price;
          this.comparePrice.hidden = !onSale;
          this.comparePrice.textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';
        }
        if (this.savingBadge) {
          const onSale = variant.compare_at_price > variant.price;
          this.savingBadge.hidden = !onSale;
          if (onSale) {
            const saving = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            this.savingBadge.textContent = `SAVE ${saving}%`;
          }
        }
      }

      updateAvailability(variant) {
        if (!this.addButton || !this.addButtonText) return;
        this.addButton.disabled = !variant.available;
        this.addButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      async copyCode(button) {
        const code = button.dataset.copyCode || '';
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
        } catch {
          const input = document.createElement('textarea');
          input.value = code;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }
        const label = button.querySelector('[data-copy-label]');
        if (label) {
          const original = label.textContent;
          label.textContent = 'Copied';
          window.setTimeout(() => { label.textContent = original; }, 1600);
        }
      }

      startCountdown() {
        const output = this.querySelector('[data-sale-countdown]');
        const value = this.dataset.saleEnd;
        if (!output || !value) return;
        const endDate = new Date(value);
        if (Number.isNaN(endDate.getTime())) return;

        const update = () => {
          const distance = endDate.getTime() - Date.now();
          if (distance <= 0) {
            output.textContent = 'Sale ended';
            window.clearInterval(this.countdownTimer);
            return;
          }
          const days = Math.floor(distance / 86400000);
          const hours = Math.floor((distance % 86400000) / 3600000);
          const minutes = Math.floor((distance % 3600000) / 60000);
          const seconds = Math.floor((distance % 60000) / 1000);
          output.textContent = `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        };

        update();
        this.countdownTimer = window.setInterval(update, 1000);
      }

      async onSubmit(event) {
        if (event.submitter && !event.submitter.matches('[data-product-add]')) return;
        event.preventDefault();
        event.stopPropagation();
        if (!this.variantInput || !this.addButton) return;

        const originalText = this.addButtonText.textContent;
        this.addButton.disabled = true;
        this.addButtonText.textContent = 'Adding…';
        if (this.message) this.message.textContent = '';

        const items = [{
          id: Number(this.variantInput.value),
          quantity: Math.max(1, Number(this.quantityInput?.value) || 1)
        }];
        this.querySelectorAll('[data-addon-variant]:checked').forEach((addon) => {
          items.push({ id: Number(addon.dataset.addonVariant), quantity: 1 });
        });

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this product.');

          if (this.message) this.message.textContent = 'Added to cart.';
          const cartButton = document.querySelector('[data-cart-open]');
          if (cartButton) cartButton.click();
        } catch (error) {
          if (this.message) this.message.textContent = error.message;
        } finally {
          const currentVariant = this.variantData.find((variant) => String(variant.id) === String(this.variantInput.value));
          this.addButton.disabled = currentVariant ? !currentVariant.available : false;
          this.addButtonText.textContent = currentVariant?.available === false ? 'Sold out' : originalText;
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.countdownTimer);
      }
    }

    customElements.define('premium-product-section', PremiumProductSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-detail-content')) {
    class ProductDetailContent extends HTMLElement {
      connectedCallback() {
        this.cleanupTasks = [];
        this.initializeReveal();
        this.initializeDeferredMedia();
        this.querySelectorAll('[data-pdc-slider]').forEach((slider) => this.initializeSlider(slider));

        this.blockSelectHandler = (event) => {
          const selected = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!selected) return;
          const slider = selected.closest('[data-pdc-slider]');
          const slides = slider ? Array.from(slider.querySelectorAll('[data-pdc-slide]')) : [];
          const index = slides.indexOf(selected);
          if (slider && index >= 0 && typeof slider.pdcGoTo === 'function') slider.pdcGoTo(index);
        };
        document.addEventListener('shopify:block:select', this.blockSelectHandler);
      }

      disconnectedCallback() {
        this.cleanupTasks.forEach((cleanup) => cleanup());
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      initializeReveal() {
        if (this.dataset.reveal !== 'true') return;

        const items = Array.from(this.querySelectorAll(':scope > .pdc__block'));
        if (!items.length) return;

        items.forEach((item) => item.setAttribute('data-pdc-reveal', ''));
        this.classList.add('pdc-reveal-ready');

        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('is-revealed'));
          return;
        }

        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        });

        items.forEach((item) => revealObserver.observe(item));
        this.cleanupTasks.push(() => revealObserver.disconnect());
      }

      initializeDeferredMedia() {
        const videos = Array.from(this.querySelectorAll('[data-pdc-autoplay-video] video'));
        if (!videos.length) return;

        if (!('IntersectionObserver' in window)) {
          videos.forEach((video) => {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          });
          return;
        }

        const mediaObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, {
          threshold: 0.15,
          rootMargin: '180px 0px'
        });

        videos.forEach((video) => mediaObserver.observe(video));
        this.cleanupTasks.push(() => mediaObserver.disconnect());
      }

      initializeSlider(slider) {
        if (slider.dataset.initialized === 'true') return;
        slider.dataset.initialized = 'true';

        const track = slider.querySelector('[data-pdc-track]');
        const viewport = slider.querySelector('[data-pdc-viewport]');
        const slides = Array.from(slider.querySelectorAll('[data-pdc-slide]'));
        const previous = slider.querySelector('[data-pdc-previous]');
        const next = slider.querySelector('[data-pdc-next]');
        const dotsContainer = slider.querySelector('[data-pdc-dots]');
        const videoToggle = slider.querySelector('[data-pdc-video-toggle]');
        const progress = slider.querySelector('[data-pdc-progress]');
        const isVideoSequence = slider.dataset.videoSequence === 'true';
        const loop = slider.dataset.loop === 'true';
        const autoplay = slider.dataset.autoplay === 'true';
        const interval = Math.max(Number(slider.dataset.interval) || 5000, 2000);
        let currentIndex = 0;
        let timer = null;
        let touchStartX = null;
        let manuallyPaused = false;
        let isVisible = !isVideoSequence;
        let visibilityObserver = null;
        const dots = [];
        const videoHandlers = [];

        if (!track || !viewport || slides.length === 0) {
          if (previous) previous.hidden = true;
          if (next) next.hidden = true;
          if (dotsContainer) dotsContainer.hidden = true;
          return;
        }

        if (slides.length < 2) {
          if (previous) previous.hidden = true;
          if (next) next.hidden = true;
          if (dotsContainer) dotsContainer.hidden = true;
        }

        const activeVideo = () => slides[currentIndex] ? slides[currentIndex].querySelector('video') : null;

        const setProgress = (value) => {
          if (!progress) return;
          const safeValue = Math.min(Math.max(value, 0), 1);
          progress.value = String(Math.round(safeValue * 1000));
          progress.style.setProperty('--pdc-progress', `${safeValue * 100}%`);
        };

        const updateVideoButton = () => {
          if (!videoToggle) return;
          const video = activeVideo();
          const paused = !video || video.paused;
          videoToggle.classList.toggle('is-paused', paused);
          videoToggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        };

        const positionTrack = () => {
          if (isVideoSequence) {
            const slide = slides[currentIndex];
            const offset = slide.offsetLeft - ((viewport.clientWidth - slide.offsetWidth) / 2);
            track.style.transform = `translate3d(-${Math.max(offset, 0)}px, 0, 0)`;
          } else {
            track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
          }
        };

        const stopAutoplay = () => {
          if (timer) window.clearInterval(timer);
          timer = null;
        };

        const playCurrentVideo = () => {
          if (!isVideoSequence) return;
          slides.forEach((slide, index) => {
            const video = slide.querySelector('video');
            if (!video) return;
            if (index !== currentIndex) {
              video.pause();
              try {
                video.currentTime = 0;
              } catch (error) {
                // The video metadata has not loaded yet.
              }
            }
          });

          const video = activeVideo();
          if (video) {
            video.muted = true;
            setProgress(video.duration ? video.currentTime / video.duration : 0);
            if (autoplay && !manuallyPaused && isVisible) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => updateVideoButton());
            }
            updateVideoButton();
          } else {
            setProgress(0);
            updateVideoButton();
          }
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!autoplay || manuallyPaused || !isVisible) return;

          if (isVideoSequence) {
            const video = activeVideo();
            if (video) {
              playCurrentVideo();
            } else if (slides.length > 1) {
              timer = window.setInterval(() => goTo(currentIndex + 1, false), interval);
            }
          } else if (slides.length > 1) {
            timer = window.setInterval(() => goTo(currentIndex + 1, false), interval);
          }
        };

        const goTo = (requestedIndex, restartAutoplay = true) => {
          if (loop) {
            currentIndex = (requestedIndex + slides.length) % slides.length;
          } else {
            currentIndex = Math.min(Math.max(requestedIndex, 0), slides.length - 1);
          }

          positionTrack();
          slides.forEach((slide, index) => {
            slide.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
          });
          dots.forEach((dot, index) => {
            const active = index === currentIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });

          if (previous) previous.disabled = !loop && currentIndex === 0;
          if (next) next.disabled = !loop && currentIndex === slides.length - 1;
          if (restartAutoplay) {
            startAutoplay();
          } else if (isVideoSequence) {
            playCurrentVideo();
          }
        };

        slider.pdcGoTo = goTo;

        if (dotsContainer) {
          slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pdc__slider-dot';
            dot.setAttribute('aria-label', `Go to card ${index + 1}`);
            dot.addEventListener('click', () => goTo(index));
            dotsContainer.appendChild(dot);
            dots.push(dot);
          });
        }

        const previousHandler = () => goTo(currentIndex - 1);
        const nextHandler = () => goTo(currentIndex + 1);
        const toggleHandler = () => {
          const video = activeVideo();
          if (!video) {
            manuallyPaused = !manuallyPaused;
            if (manuallyPaused) stopAutoplay();
            else startAutoplay();
            updateVideoButton();
            return;
          }

          if (video.paused) {
            manuallyPaused = false;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => updateVideoButton());
          } else {
            manuallyPaused = true;
            video.pause();
          }
          updateVideoButton();
        };
        const progressHandler = () => {
          const video = activeVideo();
          if (!video || !video.duration) return;
          video.currentTime = (Number(progress.value) / 1000) * video.duration;
          setProgress(video.currentTime / video.duration);
        };
        const pauseHandler = () => stopAutoplay();
        const resumeHandler = () => startAutoplay();
        const touchStartHandler = (event) => {
          touchStartX = event.changedTouches[0].clientX;
          if (!isVideoSequence) stopAutoplay();
        };
        const touchEndHandler = (event) => {
          if (touchStartX === null) return;
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) > 45) {
            goTo(currentIndex + (distance < 0 ? 1 : -1));
          } else {
            startAutoplay();
          }
          touchStartX = null;
        };
        const resizeHandler = () => positionTrack();

        if (previous) previous.addEventListener('click', previousHandler);
        if (next) next.addEventListener('click', nextHandler);
        if (videoToggle) videoToggle.addEventListener('click', toggleHandler);
        if (progress) progress.addEventListener('input', progressHandler);
        if (!isVideoSequence) {
          slider.addEventListener('mouseenter', pauseHandler);
          slider.addEventListener('mouseleave', resumeHandler);
          slider.addEventListener('focusin', pauseHandler);
          slider.addEventListener('focusout', resumeHandler);
        }
        viewport.addEventListener('touchstart', touchStartHandler, { passive: true });
        viewport.addEventListener('touchend', touchEndHandler, { passive: true });
        window.addEventListener('resize', resizeHandler);

        if (isVideoSequence) {
          if ('IntersectionObserver' in window) {
            visibilityObserver = new IntersectionObserver((entries) => {
              isVisible = entries[0].isIntersecting;
              if (isVisible) {
                startAutoplay();
              } else {
                stopAutoplay();
                const video = activeVideo();
                if (video) video.pause();
              }
            }, { threshold: 0.35 });
            visibilityObserver.observe(slider);
          } else {
            isVisible = true;
          }

          slides.forEach((slide, index) => {
            const video = slide.querySelector('video');
            if (!video) return;

            const timeHandler = () => {
              if (index !== currentIndex || !video.duration) return;
              setProgress(video.currentTime / video.duration);
            };
            const endedHandler = () => {
              if (index !== currentIndex) return;
              manuallyPaused = false;
              if (loop || currentIndex < slides.length - 1) {
                goTo(currentIndex + 1);
              } else {
                updateVideoButton();
              }
            };
            const stateHandler = () => {
              if (index === currentIndex) updateVideoButton();
            };

            video.addEventListener('timeupdate', timeHandler);
            video.addEventListener('loadedmetadata', timeHandler);
            video.addEventListener('ended', endedHandler);
            video.addEventListener('play', stateHandler);
            video.addEventListener('pause', stateHandler);
            videoHandlers.push({ video, timeHandler, endedHandler, stateHandler });
          });
        }

        this.cleanupTasks.push(() => {
          stopAutoplay();
          if (previous) previous.removeEventListener('click', previousHandler);
          if (next) next.removeEventListener('click', nextHandler);
          if (videoToggle) videoToggle.removeEventListener('click', toggleHandler);
          if (progress) progress.removeEventListener('input', progressHandler);
          if (!isVideoSequence) {
            slider.removeEventListener('mouseenter', pauseHandler);
            slider.removeEventListener('mouseleave', resumeHandler);
            slider.removeEventListener('focusin', pauseHandler);
            slider.removeEventListener('focusout', resumeHandler);
          }
          viewport.removeEventListener('touchstart', touchStartHandler);
          viewport.removeEventListener('touchend', touchEndHandler);
          window.removeEventListener('resize', resizeHandler);
          if (visibilityObserver) visibilityObserver.disconnect();
          videoHandlers.forEach(({ video, timeHandler, endedHandler, stateHandler }) => {
            video.removeEventListener('timeupdate', timeHandler);
            video.removeEventListener('loadedmetadata', timeHandler);
            video.removeEventListener('ended', endedHandler);
            video.removeEventListener('play', stateHandler);
            video.removeEventListener('pause', stateHandler);
          });
        });

        goTo(0, false);
        startAutoplay();
      }
    }

    customElements.define('product-detail-content', ProductDetailContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-benefits-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('codex-benefits-carousel')) return;

    class CodexBenefitsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-benefits-viewport]');
        this.track = this.querySelector('[data-benefits-track]');
        this.cards = Array.from(this.querySelectorAll('[data-benefit-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-benefits-dot]'));
        this.count = this.cards.length;
        this.index = 0;
        this.timer = null;
        this.resetTimer = null;
        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.interval = Math.max(2500, Number(this.dataset.interval) || 4500);
        this.transition = Math.max(200, Number(this.dataset.transition) || 450);

        if (!this.track || this.count < 1) return;

        if (this.count > 1) {
          this.cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.removeAttribute('data-benefit-card');
            clone.removeAttribute('data-block-id');
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            if (clone.matches('a, button')) clone.setAttribute('tabindex', '-1');
            clone.querySelectorAll('a, button').forEach((item) => item.setAttribute('tabindex', '-1'));
            this.track.appendChild(clone);
          });
        }

        this.onResize = () => this.goTo(this.index, false);
        this.onMouseEnter = () => this.stop();
        this.onMouseLeave = () => this.start();
        this.onFocusIn = () => this.stop();
        this.onFocusOut = () => this.start();
        this.onVisibility = () => document.hidden ? this.stop() : this.start();
        this.onTouchStart = (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
          this.stop();
        };
        this.onTouchEnd = (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(distance) > 45) {
            distance < 0 ? this.next() : this.previous();
          }
          this.start();
        };
        this.onBlockSelect = (event) => {
          const card = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!card) return;
          this.stop();
          this.goTo(this.cards.indexOf(card));
        };

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.benefitsDot));
            this.start();
          });
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.viewport.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.viewport.addEventListener('touchend', this.onTouchEnd, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.goTo(0, false);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.clearTimeout(this.resetTimer);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.viewport) {
          this.viewport.removeEventListener('touchstart', this.onTouchStart);
          this.viewport.removeEventListener('touchend', this.onTouchEnd);
        }
      }

      getStep() {
        const firstCard = this.track.querySelector('.service-benefits__card');
        if (!firstCard) return 0;
        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      setTransform(index, animate = true) {
        this.track.style.transition = animate ? `transform ${this.transition}ms ease` : 'none';
        this.track.style.transform = `translate3d(${-index * this.getStep()}px, 0, 0)`;
      }

      updateDots(index) {
        const realIndex = ((index % this.count) + this.count) % this.count;
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === realIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      }

      goTo(index, animate = true) {
        if (this.count < 1) return;
        window.clearTimeout(this.resetTimer);

        if (index < 0) index = this.count - 1;

        if (index >= this.count) {
          this.index = 0;
          this.setTransform(this.count, animate);
          this.updateDots(0);
          this.resetTimer = window.setTimeout(() => this.setTransform(0, false), this.transition + 20);
          return;
        }

        this.index = index;
        this.setTransform(index, animate);
        this.updateDots(index);
      }

      next() {
        this.goTo(this.index + 1);
      }

      previous() {
        this.goTo(this.index - 1);
      }

      start() {
        this.stop();
        if (!this.autoplay || this.count < 2 || document.hidden) return;
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('codex-benefits-carousel', CodexBenefitsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
